/**
 * Reads `#best-companies-hub-initial` JSON emitted by the hub page so the first client render
 * matches SSR HTML (Vike page context / useData can omit or empty `companies` during hydration).
 */

import type { AlgoliaCompanyRecord } from '../../types/algolia-company-record';

export type BestCompaniesHubScriptPayload = { companies: AlgoliaCompanyRecord[] };

export const BEST_COMPANIES_HUB_SCRIPT_ID = 'best-companies-hub-initial';

export function getBestCompaniesHubDataFromScript(): BestCompaniesHubScriptPayload | undefined {
  if (typeof document === 'undefined') return undefined;
  const el = document.getElementById(BEST_COMPANIES_HUB_SCRIPT_ID);
  if (!el || el.tagName !== 'SCRIPT') return undefined;
  try {
    const raw = (el as HTMLScriptElement).textContent?.trim() ?? '';
    if (!raw) return undefined;
    const parsed = JSON.parse(raw) as { companies?: unknown };
    if (!parsed || typeof parsed !== 'object') return undefined;
    if (!Array.isArray(parsed.companies)) return undefined;
    return { companies: parsed.companies as AlgoliaCompanyRecord[] };
  } catch {
    return undefined;
  }
}
